<template>
	<div class="home-background">
		<div style="width: 100%; height: 100%; position: absolute; color:#ddd; background-color: #FAFAFA; z-index: 1; left:0; top: 0; display: flex; justify-content: center; align-items: center; font-size: 50px; font-weight: bold;">
			준비 중
		</div>
		<div class="home-title">
			<div class="title-left">
				<img style="width: 16.66px; height: 26.57px;" src="@/assets/images/login/care_icon.png" />
				<span>출산 후 관리</span>
			</div>
		</div>
		<div class="search-content">
			<div class="care-btn-zone">
				<div class="care-btn" :class="isTab === 1 ? 'care-on' : ''" @click.stop="changeTap(1)">
					참여자 정보
				</div>
				<div class="care-btn" :class="isTab === 2 ? 'care-on' : ''" @click.stop="changeTap(2)">
					알림 내역
				</div>
			</div>
			<select class="list-select"></select>
			<input class="input-crud" type="text" style="width: 240px;">
			<div class="search-btn">
				<img src="@/assets/images/home/search.png"/>
				검색
			</div>
		</div>
		<div v-if="isTab === 1" class="home-bottom" style="height: calc(100% - 165px);">
			<div class="content-box">
				<table class="tb-list-vertical" style="table-layout: fixed;">
					<colgroup>
						<!-- <col width="12%">
						<col width="16%">
						<col width="16%">
						<col width="20%">
						<col width="18%">
						<col width="18%"> -->
					</colgroup>
					<thead>
						<th>참여자 번호</th>
						<th>데이터 분류</th>
						<th>수치</th>
						<th>측정 일시</th>
						<th>수신 일시</th>
						<th>상태</th>
					</thead>
					<tbody>
						<tr @click="doOpenData()">
							<td>11111</td>
							<td>혈압</td>
							<td>160/100 mmHg</td>
							<td>오늘 15:09:30</td>
							<td>오늘 15:09:30</td>
							<td><div class="status red">응급</div></td>
						</tr>
						<tr></tr>
						<tr></tr>
					</tbody>
				</table>
				<!-- <div class="pagination-wrap">
					<pagination
						:data="pagination"
						:show-disabled="true"
						:limit="4"
						@pagination-change-page="doSearchPage"
					>
						<button type="button" slot="prev-nav" class="page-prev">&lt;</button>
						<button type="button" slot="next-nav" class="page-next">&gt;</button>
					</pagination>
				</div> -->
			</div>
		</div>
		<div v-if="isTab === 2" class="home-bottom" style="height: calc(100% - 165px);">
			<div class="content-box">
				<table class="tb-list-vertical" style="table-layout: fixed;">
					<colgroup>
						<!-- <col width="12%">
						<col width="16%">
						<col width="16%">
						<col width="20%">
						<col width="18%">
						<col width="18%"> -->
					</colgroup>
					<thead>
						<th>참여자 번호</th>
						<th>데이터 분류</th>
						<th>수치</th>
						<th>측정 일시</th>
						<th>수신 일시</th>
					</thead>
					<tbody>
						<tr @click="doOpenData()">
							<td>11111</td>
							<td>혈압</td>
							<td>160/100 mmHg</td>
							<td>오늘 15:09:30</td>
							<td>오늘 15:09:30</td>
						</tr>
						<tr></tr>
						<tr></tr>
					</tbody>
				</table>
				<!-- <div class="pagination-wrap">
					<pagination
						:data="pagination"
						:show-disabled="true"
						:limit="4"
						@pagination-change-page="doSearchPage"
					>
						<button type="button" slot="prev-nav" class="page-prev">&lt;</button>
						<button type="button" slot="next-nav" class="page-next">&gt;</button>
					</pagination>
				</div> -->
			</div>
		</div>
		<CarePopup v-if="isDataPopup" />
	</div>
</template>

<script>
import Vue from "vue";
import VeeValidator from "vee-validate";
import EventBus from "@/script/EventBus.js";
import CarePopup from "@/components/care/CarePopup.vue";
Vue.use(VeeValidator);

export default {
	name: "CareList",
	created() {
		this.logger.debug(this, ".created()");
		console.log(this.userInfo.userId);
		EventBus.$emit("project-loading", false);
	},
	mounted() {
		this.logger.debug(this, ".mounted()");
	},
	data() {
		return {
			items: {},
			isMode: 1,
			isTab: 1,
			today: "",
			isDataPopup: false,
		};
	},
	components: {
		CarePopup
	},
	methods: {
		selectMode(code){
			if(code == 1){ this.isMode = 1;}
			else{this.isMode = 2;}
		},
		getDateValue() {
			var informedConsentDtTemp = this.items.informedConsentDtTemp;
			var informedConsentDt = this.items.informedConsentDt;

			if(this.utils.isEmpty(informedConsentDtTemp))
			{
				if(this.utils.isEmpty(informedConsentDt))
				{
					return "YYYY-MM-DD"
				}
				else
				{
					return informedConsentDt;
				}
			}
			else
			{
				{
					this.$set(this.items, "informedConsentDt", informedConsentDtTemp);
				}
				return this.items.informedConsentDt;
			}
		},
		clearDate() {
			this.$set(this.items, "informedConsentDt", "");
			this.$set(this.items, "informedConsentDtTemp", "");
			setTimeout(function() {
				let popup = document.getElementsByClassName("mx-datepicker-popup")[0];
				popup.style.display = "none";
			}.bind(this), 0);
		},
		doOpenData() {
			this.logger.debug(this, "doOpenData()");
			this.isDataPopup = true;
		},
		changeTap(type){
			this.isTab = type;
		}
	},
};
</script>
<style>
@import '../../assets/css/login/login.css';
.home-background{
	width: 100%;
	height: 100%;
}
.home-title{
	width: 100%;
	height: 29px;
	display: flex;
    justify-content: space-between;
}
.title-left{
	display: flex;
    align-items: center;
    column-gap: 12px;
	font-size: 24px;
	font-weight: bold;
}
.title-right{
	display: flex;
    align-items: center;
	font-size: 14px;
	column-gap: 20px;
}
.warn-dot{
	width: 16px;
	height: 16px;
	border-radius: 50px;
}
.font-red{
	color: #F94848;
}
.red{
	background-color: #F94848;
}
.yellow{
	background-color: #FFAD09;
}
.warn-wrap{
	display: flex;
	align-items: center;
    column-gap: 4px;
}
.home-top{
	width: 100%;
	height: 180px;
	display: flex;
	column-gap: 20px;
	margin: 20px 0;
}
.home-bottom{
	width: 100%;
	height: calc(100% - 269px);
	display: flex;
	column-gap: 20px;
	margin: 20px 0;
}
.content-box{
	width: 100%;
	border-radius: 8px;
	overflow: hidden;
	box-shadow: 0 0 10px 0px #ccc;
	background-color: #fff;
	position: relative;
}
.top-sub-title-red{
	width: 100%;
	height: 52px;
	background-color: #F94848;
	display: flex;
    align-items: center;
	justify-content: space-between;
    padding-left: 32px;
    color: #FFF;
	font-size: 20px;
}
.top-sub-title-green{
	width: 100%;
	height: 52px;
	background-color: #4BD985;
	display: flex;
    align-items: center;
	justify-content: space-between;
    padding-left: 32px;
    color: #FFF;
	font-size: 20px;
}
.count-dot{
	width: 8px;
	height: 8px;
	border: 1px solid #fff;
	border-radius: 50px;
}
.top-count{
	display: flex;
    column-gap: 5px;
	margin-right: 32px;
}
.white{
	background-color: #fff;
}
.none-content{
	width: 100%;
    height: calc(100% - 52px);
    display: flex;
    justify-content: center;
    align-items: center;
	font-size: 18px;
	color: #A9A9A9;
}
.left-btn{
	width: 31px;
	height: 38px;
	background-image: url(../../assets/images/home/left_btn.png);
	background-repeat: no-repeat;
	background-position: center;
	background-size: 31px 38px;
}
.right-btn{
	width: 31px;
	height: 38px;
	background-image: url(../../assets/images/home/right_btn.png);
	background-repeat: no-repeat;
	background-position: center;
	background-size: 31px 38px;
}
.name-tag{
	width: 44px;
	height: 22px;
	background-color: #EFEFEF;
	border-radius: 11px;
	font-size: 14px;
	color: #A9A9A9;
	display: flex;
    justify-content: center;
    align-items: center;
}
.data-zone{
	display: flex;
    justify-content: flex-start;
	align-items: center;
	column-gap: 10px;
	font-size: 16px;
	font-weight: bold;
}
.dot-line{
	height: 64px;
	border: 1px solid #DDDDDD;
	border-style: dashed;
}
.top-data{
	display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 4px;
}
.table-name{
	font-size: 20px;
	font-weight: bold;
	width: 100%;
	height: 60px;
	display: flex;
    align-items: center;
    justify-content: flex-start;
    column-gap: 10px;
    padding-left: 32px;
}
.table-btn{
	width: 66px;
	height: 29px;
	border-radius: 15px;
	font-size: 16px;
	font-weight: 600;
	color: #6D6D6D;
}
.table-btn:hover{
	color: #FFF;
	background-color: #555555;
}
.btn-on{
	color: #FFF;
	background-color: #555555;
}
.list-select{
	width: 240px;
	height: 40px;
    padding: 0 15px;
    border: 1px solid #A9A9A9;
	border-radius: 5px;
    font-size: 10pt;
    color: #090909;
	
}
.search-content{
	display: flex;
    align-items: center;
	column-gap: 10px;
	margin: 25px 0;
	padding-bottom: 25px;
    border-bottom: 1px solid #BDC1C6;
}
.search-btn{
	min-width: 100px;
	height: 40px;
	border-radius: 5px;
	background-color: #555555;
	color: #fff;
	display: flex;
    justify-content: center;
    align-items: center;
	column-gap: 8px;
	cursor: pointer;
	font-size: 16px;
}
.search-btn:hover{
	background-color: #0176F9;
}
.search-btn > img{
	width: 13.5px;
	height: 14.5px;
}
.status{
	min-width: 55px;
	width: 55px;
	height: 22px;
	border-radius: 12px;
	color: #fff;
	font-size: 16px;
	display: flex;
	justify-content: center;
    align-items: center;
}
.care-btn-zone{
	width: 230px;
	height: 40px;
	padding: 5px;
	background-color: #fff;
	border-radius: 5px;
	display: flex;
	align-items: center;
	padding: 0 5px;
	column-gap: 5px;
}
.care-btn{
	height: 32px;
	border-radius: 6px;
	display: flex;
    justify-content: center;
    align-items: center;
	flex: 1;
	color: #090909;
	font-size: 16px;
	font-weight: bold;
	cursor: pointer;
}
.care-btn:hover{
	background-color: #1A7AFF;
	color: #fff;
	box-shadow: 1px 1px 8px 0px rgb(0, 23, 85, 0.2);
}
.care-on{
	background-color: #1A7AFF;
	color: #fff;
	box-shadow: 1px 1px 8px 0px rgb(0, 23, 85, 0.2);
}
</style>
